export const LEGAL_NAME = 'Лемана ПРО';
export const LEGACY_LEGAL_NAME = 'Леруа Мерлен';

export const getLegalName = (isNewTheme: boolean) => (isNewTheme ? LEGAL_NAME : LEGACY_LEGAL_NAME);
